import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PrimaryButton } from '../../../shared/ui';

type RegistrationCompleteActionsProps = {
  isDisabled?: boolean;
  onContinue: () => void;
};

const Actions = styled.div.attrs({
  'data-ui': 'registration-complete-actions',
})`
  display: grid;
`;

const ContinueButton = styled(PrimaryButton)`
  justify-self: center;
`;

export function RegistrationCompleteActions({
  isDisabled = false,
  onContinue,
}: RegistrationCompleteActionsProps) {
  const { t } = useTranslation();

  return (
    <Actions>
      <ContinueButton disabled={isDisabled} type="button" onClick={onContinue}>
        {t('registrationComplete.cta')}
      </ContinueButton>
    </Actions>
  );
}
